import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  Input,
} from '../../components/index';
import User from '../../domain/User';

class ModalTipoDocumento extends Component {
  constructor() {
    super();
    this.state = {
      tipoDocumento: null,
    };
  }

  componentDidMount() {
    this.montaListaDocumentosDisponiveis();
  }

  montarListaDocumentosAdicionais = (paramLista) => {
    let lista = paramLista;
    const tiposDocumentos = this.props.tiposDocumentos ? this.props.tiposDocumentos : [];
    const inss = '01000';

    const destinatarioOuSolicitanteRGPS = User.logged().isRGPS() ||
        this.props.requerimento.destinatario === inss;

    const acordos = (destinatarioOuSolicitanteRGPS) ? [1, 3] : [2, 3];
    const regimes = User.logged().isRGPS() ? [1, 3] : [2, 3];

    lista = tiposDocumentos.filter(doc => (
      // 1: Aposentadoria
      // 2: Pensao
      // Nulo: Ambos (Não havia sido acordado se "3" seria para ambos.
      // Por enquanto "null" no banco significa ambos)
      (doc.abrangenciaAplicavel === this.props.tipoRequerimento ||
          doc.abrangenciaAplicavel == null) &&
      acordos.includes(doc.acordoAplicavel) &&
      regimes.includes(doc.regimeAplicavel)
    ));
    return lista;
  }

  montaListaDocumentosDisponiveis = () => {
    const lista = this.montarListaDocumentosAdicionais(this.props.requerimento);
    this.setState({
      tiposDisponiveis: lista,
    });
  }

  checkIfFileCanBeSent = () => (this.state.tipoDocumento)

  alterarTipoDocumento = () => {
    const tipoDocumentoCarregado = this.state.tipoDocumento;
    this.props.alterarTipoDocumento(tipoDocumentoCarregado);
  }


  modalTipoDocumentoContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="8 8 12 12">
          <Input
            label="Tipo de documento"
            number
            placeholder="Selecione o tipo de documento"
            onChange={e => this.handleChange(e, 'tipoDocumento')}
            value={this.state.tipoDocumento}
            itemList={this.state.tiposDisponiveis}
            required
            custom
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  modalTipoDocumentoFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={!this.checkIfFileCanBeSent()}
          hint="Alterar tipo de documento"
          onClick={this.alterarTipoDocumento}
          title="Salvar"
        />
      </div>
    </React.Fragment>
  )

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleClose = () => {
    this.setState({ tipoDocumento: null }, this.props.handleModal('showDocumentUploadModal'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalTipoDocumentoFooter()}
        conteudomodal={this.modalTipoDocumentoContent()}
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="Alterar Tipo de documento"
      />
    );
  }
}

ModalTipoDocumento.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  pagamento: PropTypes.objectOf(PropTypes.object).isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  handleDocumentSent: PropTypes.func,
}.isRequired;

export default ModalTipoDocumento;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalTipoDocumento.jsx